export default {
	project_name: 'TCL Experts',
	document: 'DNI',
	point: 'Star | Stars',
	points: 'Stars',
	point_plural: 'Stars',
	score: 'Stars',
	points_earned: 'Estrellas Ganadas',
	my_points: 'Mis Estrellas',
	points_table: 'Tabla de Estrellas',
	acc_score: 'Estrella acumulada | Estrellas acumuladas',
}
